import CourseOverviewContainer from './CourseOverviewContainer';
export default CourseOverviewContainer;
